document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.fruit-collection-grid-section');

  if (!section || !section.classList.contains('has-filters')) {
    return;
  }

  /* =================================================
     MOBILE / TABLET — DRAWER
     ================================================= */

  (function () {
    const overlay = document.querySelector('[data-fruit-drawer-overlay]');
    const drawer = document.querySelector('[data-fruit-drawer]');
    const openBtn = document.querySelector('[data-fruit-open-filters]');
    const closeBtn = document.querySelector('[data-fruit-close-filters]');

    if (!overlay || !drawer || !openBtn) return;

    function openDrawer() {
      overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeDrawer() {
      overlay.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    openBtn.addEventListener('click', openDrawer);

    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeDrawer();
    });
  })();

  /* =================================================
     DESKTOP — FACETS POR CLIQUE
     ================================================= */

  const desktopFacets = document.querySelectorAll(
    '.fruit-facets__bar--desktop .fruit-facet'
  );

  desktopFacets.forEach(facet => {
    const title = facet.querySelector('.fruit-facet__title');
    const options = facet.querySelector('.fruit-facet__options');

    if (!title) return;

    title.addEventListener('click', (event) => {
      event.stopPropagation();

      desktopFacets.forEach(other => {
        if (other !== facet) other.classList.remove('is-open');
      });

      facet.classList.toggle('is-open');
    });

    if (options) {
      options.addEventListener('click', (event) => {
        event.stopPropagation();
      });
    }
  });

  document.addEventListener('click', () => {
    desktopFacets.forEach(facet => facet.classList.remove('is-open'));
  });
});
